import { useNavigate, useLocation } from "react-router-dom";
import { Box, Flex, Text, Paper, ThemeIcon, Button } from "@mantine/core";
import { IconCircleCheck } from "@tabler/icons-react";

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Get data from navigation state
  const paymentData = location.state?.paymentData || {
    transactionId: "TXN-2025-0115-7890",
    amountPaid: 308,
    date: new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" }),
  };

  // const matchId = location.state?.matchId;
  const companyId = location.state?.companyId;

  const handleOpenNda = () => {
    if (companyId) {
      navigate(`/interests/${companyId}/nda`);
    } else {
      navigate("/collaborations/nda");
    }
  };

  return (
    <Flex direction="column" align="center" py="xl" px="md" mih="100vh">
      {/* Main Card */}
      <Paper radius="lg" p="xl" maw={1200} w="100%">
        {/* Success Banner */}
        <Paper
          radius="lg"
          withBorder
          p="xl"
          mb="xl"
          style={{
            background: "linear-gradient(to bottom, var(--mantine-color-green-0), white)",
          }}
        >
          <Flex direction="column" align="center" gap="sm">
            <ThemeIcon size={64} radius={64} color="green" variant="light">
              <IconCircleCheck size={36} />
            </ThemeIcon>
            <Text fz="xl" fw={400} ta="center">
              Payment Successful!
            </Text>
            <Text c="slate.5" fz="sm" ta="center">
              Your collaboration workspace is now active
            </Text>
          </Flex>
        </Paper>

        {/* Payment Details */}
        <Paper radius="lg" withBorder p="lg" mb="lg">
          <Text fw={400} mb="md">
            Payment Details
          </Text>

          <Flex direction="column" gap="sm">
            <Flex justify="space-between" align="center">
              <Text fz="sm" c="slate.5">
                Transaction ID
              </Text>
              <Text fz="sm" fw={400}>
                {paymentData.transactionId}
              </Text>
            </Flex>

            <Flex justify="space-between" align="center">
              <Text fz="sm" c="slate.5">
                Amount Paid
              </Text>
              <Text fz="sm" fw={400}>
                ${paymentData.amountPaid}
              </Text>
            </Flex>

            <Flex justify="space-between" align="center">
              <Text fz="sm" c="slate.5">
                Date
              </Text>
              <Text fz="sm" fw={400}>
                {paymentData.date}
              </Text>
            </Flex>
          </Flex>
        </Paper>

        {/* What's Next */}
        <Paper
          radius="lg"
          p="lg"
          mb="xl"
          style={{
            background: "#2563EB0D",
            border: "1px solid #2563EB33",
          }}
        >
          <Text fw={400} mb="md">
            What's Next?
          </Text>

          <Flex direction="column" gap="lg">
            {/* Step 1 */}
            <Flex gap="md" align="flex-start">
              <ThemeIcon size={32} radius={32} color="primary">
                <Text fz="xs" fw={400} c="white">
                  1
                </Text>
              </ThemeIcon>
              <Box>
                <Text fz="sm" fw={400}>
                  Access Your Workspace
                </Text>
                <Text fz="xs" c="slate.5">
                  View full company details and start collaborating
                </Text>
              </Box>
            </Flex>

            {/* Step 2 */}
            <Flex gap="md" align="flex-start">
              <ThemeIcon size={32} radius={32} color="primary">
                <Text fz="xs" fw={400} c="white">
                  2
                </Text>
              </ThemeIcon>
              <Box>
                <Text fz="sm" fw={400}>
                  Sign the NDA
                </Text>
                <Text fz="xs" c="slate.5">
                  Review and accept the auto-generated NDA
                </Text>
              </Box>
            </Flex>

            {/* Step 3 */}
            <Flex gap="md" align="flex-start">
              <ThemeIcon size={32} radius={32} color="primary">
                <Text fz="xs" fw={400} c="white">
                  3
                </Text>
              </ThemeIcon>
              <Box>
                <Text fz="sm" fw={400}>
                  Begin Collaboration
                </Text>
                <Text fz="xs" c="slate.5">
                  Share documents and track progress
                </Text>
              </Box>
            </Flex>
          </Flex>
        </Paper>

        {/* Action Buttons */}
        <Flex gap="md" justify="center">
          <Button fullWidth onClick={handleOpenNda}>
            Sign NDA
          </Button>
        </Flex>
      </Paper>
    </Flex>
  );
}
